// extracted by mini-css-extract-plugin
export default {"module":"textarea_module__DIm68"};